/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";



export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { openEditObjectPage, openDeleteObjectDialog, openFloorsPage, openRoomsPage, openRefreshObjectDialog, isFullAccess = true }
) => (
  <div className="float-right border-0 ">

    {openFloorsPage &&
      <td className="border-0 ml-0 mr-0">
        <OverlayTrigger
          overlay={<Tooltip id="objects-floors-tooltip">طبقات</Tooltip>}
        >
          <a
            className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
            onClick={() => {
              openFloorsPage(row.id, row.title)
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Home/Commode2.svg")}
              />
            </span>
          </a>
        </OverlayTrigger>
      </td>
    }

    {openRoomsPage &&
      <td className="border-0 ml-0 mr-0">
        <OverlayTrigger
          overlay={<Tooltip id="objects-rooms-tooltip">لیست اتاق ها</Tooltip>}
        >
          <a
            className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
            onClick={() => openRoomsPage(row.id)}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Home/Home.svg")}
              />
            </span>
          </a>
        </OverlayTrigger>
      </td>
    }

    <td className="border-0 ml-0 mr-0">
      <OverlayTrigger
        overlay={<Tooltip id="objects-edit-tooltip">ویرایش</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
          onClick={() => openEditObjectPage(row.id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
            />
          </span>
        </a>
      </OverlayTrigger>
    </td>


    {!row.isDeleted && isFullAccess &&
      <td className="border-0 ml-0 mr-0">
        <OverlayTrigger
          overlay={<Tooltip id="objects-delete-tooltip">غیرفعالسازی</Tooltip>}
        >
          <a
            className="btn btn-icon btn-light btn-hover-danger btn-sm"
            onClick={() => openDeleteObjectDialog(row.id)}
          >
            <span className="svg-icon svg-icon-md svg-icon-danger">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
            </span>
          </a>
        </OverlayTrigger>
      </td>}
    {row.isDeleted && isFullAccess &&
      <td className="border-0 ml-0 mr-0">
        <OverlayTrigger
          overlay={<Tooltip id="objects-delete-tooltip">فعالسازی</Tooltip>}
        >
          <a
            className="btn btn-icon btn-light btn-hover-success btn-sm"
            onClick={() => openRefreshObjectDialog(row.id)}
          >
            <span className="svg-icon svg-icon-md svg-icon-success">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Update.svg")} />
            </span>
          </a>
        </OverlayTrigger>
      </td>}
  </div>
);
